import { render, staticRenderFns } from "./MyApprovalTasks.vue?vue&type=template&id=360273e0&scoped=true"
import script from "./MyApprovalTasks.vue?vue&type=script&lang=js"
export * from "./MyApprovalTasks.vue?vue&type=script&lang=js"
import style0 from "./MyApprovalTasks.vue?vue&type=style&index=0&id=360273e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360273e0",
  null
  
)

export default component.exports